<template>
  <div
    v-if="form"
    class="my-2"
  >
    <div class="row">
      <div class="col-md-7">
        <div class="mb-3">
          <span class="h4">#{{ request.id }}</span> <span class="lead">{{ form.name }}</span>
          <code
            style="cursor: pointer"
            @click="$emit('companyPopup', {company:form.company, profile: 'PROCUREMENT'})"
          >
            [{{ form.company.name }} {{ getCompanyFormat(form.company.format) }}]
          </code>
        </div>
        <strong>{{ $t('supplierOutgoingVendorRequest.mllif') }} </strong> {{ request.user.name }} {{ request.user.surname }} <br>
        <strong>{{ $t('supplierOutgoingVendorRequest.doldurulmaVaxt') }} </strong> {{ getMoment(request.createTime) }} <br>
        <strong>{{ $t('supplierOutgoingVendorRequest.sonDyiiklikVaxt') }} </strong> {{ getMoment(request.lastUpdateTime) }}<br>
        <strong>{{ $t('supplierOutgoingVendorRequest.gndrilmVaxt') }} </strong> {{ getMoment(request.sendTime) }}<br>
        <strong>{{ $t('companyFormAdminView.status') }}</strong>
        <CompanyFormRequestStatus :status="request.status" />

        <hr>

        <div v-for="s in sections">
          <h5>{{ s.title }}</h5>

          <div class="row">
            <template v-for="(i,j) in sectionInputs[s.id]">
              <VendorManagementDataView
                :key="values[i]"
                :input="i"
                :model-value="values[i.id]"
              />
            </template>
          </div>
          <hr>
        </div>
        <div v-if="form.profileType==='SUPPLIER'">
          <h5>{{ $t('companySearch.faliyytSahlri') }}</h5>

          <div>
            <label
              v-for="s in sectors"
              class="d-block"
            >
              <input
                class="checkbox_animated"
                type="checkbox"
                disabled
                :checked="selectedSectors.indexOf(s.id+'')>-1"
              >
              {{ s.name }}
            </label>
          </div>
          <hr>
        </div>
      </div>
      <div class="col-md-5 position-relative">
        <div class="card border border-dark sticky-top">
          <div class="card-body h-100">
            <div class="chat-box">
              <div class="chat-right-aside">
                <div class="chat">
                  <div class="chat-history chat-msg-box custom-scrollbar">
                    <ul>
                      <li
                        v-for="m in messages"
                        :key="m.id"
                        :class="`${m.author==='supplier'?'pl-5':'pr-5'}`"
                      >
                        <div
                          class="message"
                          :class="`${m.author==='supplier'?'other-message':'my-message'}`"
                        >
                          <img
                            v-if="m.author === 'procurement'"
                            alt=""
                            :src="getPhoto(form.company.logo,'thumbnailCropped')"
                            class="rounded-circle border bg-white float-left chat-user-img img-30"
                          >

                          <img
                            v-else
                            alt=""
                            :src="getPhoto(request.company.logo,'thumbnailCropped')"
                            class="rounded-circle border bg-white float-right chat-user-img img-30"
                          >

                          <div class="message-data mb-0 ">
                            <span class="message-data-time">{{ m.logTime }}</span>
                          </div>
                          {{ m.comment }}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="request.conversationActive"
            class="card-footer bg-light"
          >
            <form @submit.prevent="sendMessage">
              <div class="input-group">
                <input
                  v-model.trim="messageText"
                  type="text"
                  class="form-control"
                  :placeholder="$t('vendorRequestDetails.mesajMtniniDaxilEdin')"
                  required
                >
                <div class="input-group-append">
                  <button
                    type="submit"
                    class="btn btn-success"
                  >
                    <feather
                      type="send"
                      size="12"
                    />
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div
            v-else
            class="card-footer text-danger"
          >
            {{ $t('vendorRequestDetails.buMracitNMzakirAktivDeyilQarTrfMesajYazdndaMzakirA') }}
          </div>
        </div>
      </div>
    </div>


    <div v-if="['DRAFT'].indexOf(request.status)>-1">
      <button
        class="btn btn-success mr-2"
        @click="requestIsReady"
      >
        {{ $t('supplierOutgoingVendorRequest.hazrdr') }}
      </button>
      <button
        class="btn btn-primary mr-2"
        @click="editRequest"
      >
        {{ $t('newAUCRequest.dzliEt') }}
      </button>
    </div>
    <div v-else-if="['WAITING'].indexOf(request.status)>=0">
      <button
        class="btn btn-danger mr-2"
        @click="requestIsReady"
      >
        {{ $t('vendorRequestDetails.gndriiLvEt') }}
      </button>
    </div>
    <div v-else-if="['READY','RETURNED','EXPIRED'].indexOf(request.status)>=0">
      <button
        class="btn btn-success mr-2"
        @click="sendForReview"
      >
        {{ $t('vendorRequestDetails.mracitiGndr') }}
      </button>
      <button
        class="btn btn-primary mr-2"
        @click="editRequest"
      >
        {{ $t('newAUCRequest.dzliEt') }}
      </button>
      <button
        v-if="request.status !== 'READY'"
        class="btn btn-danger mr-2"
        @click="requestIsReady"
      >
        {{ $t('vendorRequestDetails.gndriiLvEt') }}
      </button>
    </div>

    <div
      v-else-if="['REJECTED'].indexOf(request.status)>=0"
      class="text-danger"
    >
      {{ $t('vendorRequestDetails.buFormaYenidnAktivldirilBilmzYenidnSoruDoldurmaqNM') }}
    </div>
  </div>
</template>
<script>
import {
  getFormRequestById, getFormRequestMessages,
  getOfflineForm, handleErrors,
  sendFormRequestForApproval, sendFormRequestReady, sendMessage
} from "@/repositories/VendorManagementRepository";
import {mapState} from "vuex";
import VendorManagementDataView from "@/pages/scc/vendorManagement/builder/VendorManagementDataView.vue";
import {getCompanyFormat, getPhoto} from "@/repositories/Utils";
import CompanyFormRequestStatus from "@/pages/scc/vendorManagement/utils/CompanyFormRequestStatus.vue";
import moment from "moment";

export default {
  name: 'VendorRequestDetails',
  components: {CompanyFormRequestStatus, VendorManagementDataView},
  props: {
    activeRequestId: {}
  },
  data() {
    return {
      form: null,
      inputs: [],
      sections: [],
      sectors: [],
      values: [],
      selectedSectors: [],
      sectionInputs: {},
      request: null,
      messages: [],
      messageText: ''
    };
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
    }),
  },

  mounted() {
    this.getRequestDetails();
    this.getRequestMessages(true);
    this.messageTimer = setInterval(() => {
      this.getRequestMessages(false);
    }, 10000)
  },

  unmounted() {
    clearInterval(this.messageTimer);
  },

  methods: {
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },

    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    calculateSectionInputs() {

      let map = {};

      this.sections.forEach((s) => {
        map[s.id] = [];
      })

      this.inputs.forEach((i) => {
        i.hash = JSON.stringify(i);
        map[i.companyFormSectionId].push(i);
      })

      this.sectionInputs = map;
    },

    getFormDetails(formId) {

      getOfflineForm(formId, this.$i18n.locale).then(({code, form, sections, sectors, inputs, message, errorCode}) => {
        if (code === 200) {
          this.form = form;
          this.sections = sections;
          this.inputs = inputs.sort((a, b) => a.listOrder - b.listOrder);;
          console.log(inputs);
          this.sectors = sectors;

          this.calculateSectionInputs();

        } else if (code === 404) {
          this.$swal({
            title: this.$t("general.notFound"),
            text: this.$t("axtrdgnzFrmTpldm"),
            icon: 'error'
          }).then(() => {
            this.$router.back();
          })
        } else {
          handleErrors(this.$swal, data,null);
        }
      })
    },

    getRequestDetails() {
      getFormRequestById(this.token, this.activeRequestId).then(({code, form, message, errorCode}) => {
        if (code === 200) {
          this.values = JSON.parse(form.response);

          this.selectedSectors = form.sectors === null ? [] : form.sectors.split(',');
          this.request = form;

          this.getFormDetails(form.companyForm.id);

        } else if (code === 404) {
          this.$swal({
            title: this.$t("general.notFound"),
            text: this.$t("axtrdgnzFrmTpldm"),
            icon: 'error'
          }).then(() => {
            this.$router.back();
          })
        } else {
          handleErrors(this.$swal, form,null);
        }
      })
    },


    getRequestMessages(scroll) {
      getFormRequestMessages(this.token, this.activeRequestId).then(({
                                                                       code,
                                                                       messages,
                                                                       isConversationActive,
                                                                     }) => {
        if (code === 200) {

          this.messages = messages;
          this.request.conversationActive = isConversationActive;

          if(scroll){
            setTimeout(()=>{
              let container = document.querySelector(".chat-history");
              if (container) {
                container.scrollTop = container.scrollHeight;
              }
            },500);
          }
        }
      })
    },


    sendMessage() {

      sendMessage(this.token, this.activeRequestId, this.messageText)
          .then(({code, message, errorCode}) => {
            if (code === 200) {
              this.getRequestMessages(true);
              this.messageText = '';
            } else if (code === 404) {
              this.$swal({
                title: this.$t("general.notFound"),
                text: this.$t("axtrdgnzFrmTpldm"),
                icon: 'error'
              }).then(() => {

              })
            } else {
              handleErrors(this.$swal, data,null);
            }
          })
    },


    sendForReview() {
      this.$swal({
        title: this.$t("generalModal.warningTitle"),
        icon: 'question',
        text: this.$t("tsdqGndrmyMnsnz"),
        showCancelButton: true,
        confirmButtonText: this.$t("body.gndr"),
        cancelButtonText: this.$t("companyProfile.lvEt2"),
      }).then((result) => {
        if (result.value) {
          sendFormRequestForApproval(this.token, this.activeRequestId)
              .then(({code, id, message, errorCode}) => {
                if (code === 200) {
                  this.$swal({
                    title: this.$t("generalModal.successTitle"),
                    text: this.$t("srgnzGndrld"),
                    icon: 'success'
                  }).then(() => {
                    this.getRequestDetails();
                  });

                } else if (code === 404) {
                  this.$swal({
                    title: this.$t("general.notFound"),
                    text: this.$t("axtrdgnzFrmTpldm"),
                    icon: 'error'
                  }).then(() => {

                  })
                } else {
                  handleErrors(this.$swal, {code, message, errorCode},null);
                }
              })
        }
      });
    },

    requestIsReady() {
      sendFormRequestReady(this.token, this.activeRequestId)
          .then(({code, id, message, errorCode}) => {
            if (code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("dyrlndrmFrmnzHzrdStts"),
                icon: 'success'
              }).then(() => {
                this.getRequestDetails();
              });

            } else if (code === 404) {
              this.$swal({
                title: this.$t("general.notFound"),
                text: this.$t("axtrdgnzFrmTpldm"),
                icon: 'error'
              }).then(() => {

              })
            } else {
              handleErrors(this.$swal, data,null);
            }
          })
    },

    editRequest() {
      this.$router.push(
          {name: 'vendorFormView', params: {id: this.form.id}, query: {request: this.activeRequestId}}
      )
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
